import { IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

/**
 * To use Header Grid :
 * Pass a React useRef to the grid component.
 * Import Module Ag-Grid ExcelExportModule in the parent component.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.gridRef - A reference to the grid component.
 */
const ExcellExport = ({ gridRef }) => {
  const exportExcel = () => {
    gridRef?.current?.api?.exportDataAsExcel();
  };

  return (
    <div style={{}}>
      <IconButton
        aria-label="export"
        onClick={exportExcel}
        color="inherit"
        size="large"
      >
        <FileDownloadIcon />
      </IconButton>
    </div>
  );
};

export default ExcellExport;
